module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/Instagram-icon-932a5b758be532a4037db61716ef716b.png";